const SYSTEM_JS_URL = "https://unpkg.com/systemjs/dist/system.js";

let systemLoadPromise: Promise<void> | null = null;

function hasSystem(w: Window): w is Window & { System: { import: (m: string) => Promise<unknown> } } {
  return (w as unknown as { System?: unknown }).System != null;
}

/**
 * Load SystemJS when a widget uses a non-`es6` format (legacy ParcelLoader contract).
 */
export function ensureSystemJs(): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.resolve();
  }
  if (hasSystem(window)) {
    return Promise.resolve();
  }
  if (systemLoadPromise) {
    return systemLoadPromise;
  }
  systemLoadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-bronte-spa-system]`);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("SystemJS script error")));
      return;
    }
    const script = document.createElement("script");
    script.src = SYSTEM_JS_URL;
    script.async = true;
    script.crossOrigin = "anonymous";
    script.dataset.bronteSpaSystem = "1";
    script.addEventListener("load", () => resolve());
    script.addEventListener("error", () => reject(new Error("Failed to load SystemJS")));
    document.head.appendChild(script);
  });
  return systemLoadPromise;
}
